import { useMemo } from "react";

import { useReportContext } from "../../report-context";
import { FormattedTableRowData } from "../types";

import { ReportColumn } from "@/types/evaluate";

export const useFormattedTableData = (data: number[]) => {
  const reportContext = useReportContext();
  const { sortedColumns, reportCells } = reportContext;

  const cellsKey = useMemo(() => {
    if (!reportCells) {
      return "";
    }
    return reportCells
      .reduce((acc: string[], cell) => {
        acc.push(
          `${cell.id}-${cell.dataset_row_id}-${cell.report_column_id}-${cell?.display_value?.value}-${cell.status}`,
        );
        return acc;
      }, [])
      .join("-");
  }, [reportCells]);

  const tableData: FormattedTableRowData[] = useMemo(() => {
    if (!data || data.length === 0) {
      return [];
    }

    const columnIds = sortedColumns
      .map((column: ReportColumn) => column.id)
      .filter((id: number | undefined): id is number => id !== undefined && id !== null);

    return data.map((rowId, index) => {
      const rowData: FormattedTableRowData = {
        id: rowId,
        rowIndex: index,
      };

      for (const columnId of columnIds) {
        const cell = reportContext.getCellByRowAndColumn(rowId, columnId);
        const column = reportContext.getColumnById(columnId);

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (rowData as any)[String(columnId)] = {
          rowId,
          columnId,
          cell,
          column,
        };
      }

      return rowData;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, sortedColumns, cellsKey]);

  return {
    tableData,
    isLoading: reportContext.visibleRows === null || reportContext.reportCells === null,
  };
};
